import { isPrivyReadyVar } from './store'

/**
 * Functions that only exist inside the lazily loaded Privy chunk
 * (`app/privy-root.tsx`). Privy-free UI (sign-in button, nickname dialog,
 * logout) reaches the SDK through this bridge, so `@privy-io/react-auth`
 * never lands in the legacy bundle.
 */
export interface PrivySessionBridge {
  /** Opens the Privy login modal. */
  login: () => void
  /** Clears the Privy session (tokens in local storage). */
  logout: () => Promise<void>
  /** Retries `signInPrivy` with the nickname a new user picked. */
  submitUsername: (username: string) => Promise<void>
  /** Privy's export modal for the embedded wallet's private key (FE-304). */
  exportWallet: () => Promise<void>
  /**
   * Opens a new XYRO session after the old one expired, when Privy is still
   * signed in. Resolves `false` when there is no Privy session to open it from.
   */
  restoreSession: () => Promise<boolean>
}

let bridge: PrivySessionBridge | null = null

export const setPrivySessionBridge = (next: PrivySessionBridge | null) => {
  bridge = next
  isPrivyReadyVar(next !== null)
}

export const getPrivySessionBridge = () => bridge
